import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {FlowSessionDetails} from '../../models/underwriter.model';

export interface FlowState extends EntityState<FlowSessionDetails> {
}

export function createInitialState(): FlowState {
  return {
    session_id: '',
    state: 'Pending',
    category_id: 0,
    flow_id: 0,
    item_id: '0',
    class_id: 0,
    group_id: 0,
    superflow_id: 0,
    css: '',
    emergency_code: 0
  };
}

@Injectable({
  providedIn: 'root'
})
export class QuestionFlowSessionStore extends SignalEntityStore<FlowSessionDetails, FlowState> {
  constructor() {
    super({name: 'question-flow-session', initialState: createInitialState()});
  }
}
